import React, { useMemo } from 'react';
import { Stepper } from '@shared/components/Stepper';
import { VerifyIdentity } from './steps/VerifyIdentity';
import { EnterOTP } from './steps/EnterOTP';
import { SetPassword } from './steps/SetPassword';
import { Done } from './steps/Done';
import { ArrowLeft, Zap } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const ForgotPasswordLanding = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { tenant, utilityName } = useParams<{ tenant?: string; utilityName?: string }>();

  const steps = useMemo(() => [
    {
      title: t("Verify Identity"),
      slug: 'verify-identity',
      component: <VerifyIdentity />
    },
    {
      title: t("Enter OTP"),
      slug: 'enter-otp',
      component: <EnterOTP />
    },
    {
      title: t("New Password"),
      slug: 'new-password',
      component: <SetPassword />
    },
    {
      title: t("Done"),
      slug: 'done',
      component: <Done />
    }
  ], [t]);

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a1526] via-[#103063] to-[#1e52a8] flex flex-col items-center p-4 font-sans justify-center">
      
      {/* Logo Area */}
      <div className="mb-8 flex flex-col items-center">
        <div className="flex items-center gap-3 text-white">
          <div className="p-1.5 bg-white/10 rounded-lg backdrop-blur-sm">
            <Zap className="text-blue-300 h-5 w-5" />
          </div>
          <div className="font-bold text-sm tracking-widest text-center leading-tight">
            SMART360<br/><span className="text-blue-200 text-[10px]">UTILITY PORTAL</span>
          </div>
        </div>
      </div>

      <div className="bg-[#F8F9FA] rounded-[2rem] w-full max-w-[680px] p-4 md:p-6 shadow-2xl border border-white/20">
        
        <button 
          onClick={() => navigate(tenant && utilityName ? `/login/${tenant}/${utilityName}` : '/login')}
          className="flex items-center text-sm text-slate-500 hover:text-slate-800 mb-6 font-medium pl-2 pt-2"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          {t("Back to Login")}
        </button>

        <Stepper
          steps={steps}
          enableRouting={true}
          storageKey="forgot-password-stepper"
          autoSave={false}
          persistProgress={false}
          allowStepClick={false}
        />
      </div>

      {/* Footer */}
      {/* <div className="mt-8 text-white/50 text-xs text-center">
        © 2024 City of Lakewood Water & Sewer Authority
      </div> */}
    </div>
  );
};
